import React from "react";
import { Alert, AlertTitle, Box } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface ErrorDisplayProps {
  message?: string;
  showIcon?: boolean;
  severity?: "error" | "warning";
  title?: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  message = "An error occurred.",
  showIcon = true,
  severity = "error",
  title
}) => {
  return (
    <Box sx={{ maxWidth: "500px", mx: "auto", mt: 2, mb: 2 }}>
      <Alert 
        severity={severity}
        icon={showIcon ? <ErrorOutlineIcon /> : false}
        sx={{ 
          '& .MuiAlert-icon': { 
            fontSize: '2rem',
            alignItems: 'center'
          },
          padding: 2
        }}
      >
        {title && <AlertTitle sx={{ fontWeight: 'medium' }}>{title}</AlertTitle>}
        {message}
      </Alert>
    </Box>
  );
};
